import { Col, Image, Row, Typography } from 'antd';
import dmcaImage from '../../assets/dmcaproteted.png';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { styles } from '../../styles';
import { SITE_NAME, SITE_URL } from '../../utils/constant';

const linkStyle: React.CSSProperties = {
  color: 'var(--bs-muted)',
};

const mutedStyle: React.CSSProperties = {
  color: 'var(--bs-muted)',
};

export default function FooterComponent() {
  return (
    <>
      <Row gutter={24} style={{ ...styles.flexDisplay, marginBottom: '10px' }}>
        <Col span={16}>
          <Row gutter={24} style={styles.flexDisplay}>
            <Image width={80} src={dmcaImage} preview={false} alt="DMCA protected" />
          </Row>
          <Row gutter={24}>
            <Typography.Text style={mutedStyle}>
              Disclaimer: This website does not host any of the videos mentioned. Streams originating
              from external platforms such as YouTube are merely provided with links for convenience.
              It is important to note that this website bears no responsibility for the legality of
              the content. Any legal inquiries or issues should be directed to the respective media
              file owners or hosting platforms.
            </Typography.Text>
          </Row>
        </Col>
      </Row>
      <Row gutter={24} style={styles.flexDisplay}>
        <Col span={4}>
          <Typography.Text
            style={{
              color: 'var(--bs-text)',
              fontFamily: 'Oswald, sans-serif',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
            }}
          >
            Buff<span style={{ color: 'var(--bs-accent)' }}>streams</span>
          </Typography.Text>
        </Col>
        <Col span={4}>
          <Link to="/about-us">
            <Typography.Text style={linkStyle}>About Us</Typography.Text>
          </Link>
        </Col>
        <Col span={4}>
          <Link to="/privacy-policy">
            <Typography.Text style={linkStyle}>Privacy Policy</Typography.Text>
          </Link>
        </Col>
        <Col span={4}>
          <Link to="/contact">
            <Typography.Text style={linkStyle}>Contact Us</Typography.Text>
          </Link>
        </Col>
        <Col span={8}>
          <Typography.Text style={mutedStyle}>
            Copyright © {dayjs(new Date()).format('YYYY')} {SITE_NAME}. All rights reserved.{' '}
            {SITE_URL.replace('https://', '')}
          </Typography.Text>
        </Col>
      </Row>
    </>
  );
}
